import { OrderType } from '../order/types'
import { Security } from '../securities/reducer'
import { RFQActions } from './actions'
import { QuoteRequest } from './types'

type SecurityQuoteRequest = Record<Security['id'], QuoteRequest>
type ActivityQuoteRequest = Record<number, QuoteRequest>
type SecurityErrors = Record<Security['id'], { type: OrderType; error: string }>

export interface State {
  securityQuotes: SecurityQuoteRequest
  securityErrors: SecurityErrors
  rfqActivity: ActivityQuoteRequest
}

export const getInitialState = () => {
  return {
    securityQuotes: {},
    securityErrors: {},
    rfqActivity: {}
  } as State
}

export default (state = getInitialState(), action: RFQActions) => {
  const { securityQuotes, securityErrors } = state
  switch (action.type) {
    case 'rfq.fetchRFQsSuccess': {
      const updates: SecurityQuoteRequest = action.payload.quoteRequests.reduce(
        (u, qr) => {
          u[qr.securityId] = qr
          return u
        },
        {} as SecurityQuoteRequest
      )
      return {
        ...state,
        securityQuotes: { ...securityQuotes, ...updates }
      }
    }
    case 'rfq.fetchRFQActivitySuccess': {
      const updates: ActivityQuoteRequest = action.payload.quoteRequests.reduce(
        (u, qr) => {
          if (qr.requestId !== undefined) {
            u[qr.requestId] = qr
          }
          return u
        },
        {} as ActivityQuoteRequest
      )
      return {
        ...state,
        rfqActivity: { ...state.rfqActivity, ...updates }
      }
    }
    case 'rfq.submitRfq': {
      const { [action.payload.order.securityId]: _securityError, ...errors } =
        securityErrors
      return {
        ...state,
        securityErrors: errors
      }
    }
    case 'rfq.cancelRfqFailure':
    case 'rfq.submitRFQFailure': {
      return {
        ...state,
        securityErrors: {
          ...securityErrors,
          [action.payload.securityId]: {
            error: action.payload.error.message ?? '',
            type: action.payload.type
          }
        }
      }
    }
    case 'rfq.cancelRfqSuccess': {
      const { [action.payload.securityId]: _deletedRequest, ...requests } =
        securityQuotes
      return {
        ...state,
        securityQuotes: requests
      }
    }
    case 'rfq.acceptRfqQuoteFailure':
    case 'rfq.rejectRfqQuoteFailure': {
      return {
        ...state,
        securityErrors: {
          ...securityErrors,
          [action.payload.securityId]: {
            error: action.payload.message,
            type: action.payload.type
          }
        }
      }
    }
    case 'rfq.dismissRfqError': {
      const { [action.payload.securityId]: _deletedError, ...errors } =
        securityErrors
      return {
        ...state,
        securityErrors: errors
      }
    }
  }
  return state
}
